export const palettePurple = {
  primary: {
    lighter: '#F3E5F5',
    light: '#CE93D8',
    main: '#9C27B0', // Purple 500 - Primary
    dark: '#7B1FA2',
    darker: '#4A148C', 
    contrastText: '#ffffff',
  },
  secondary: {
    lighter: '#EDE7F6',
    light: '#B39DDB',
    main: '#673AB7', // Deep Purple
    dark: '#512DA8',
    contrastText: '#ffffff',
  },
  error: {
    light: '#EF5350',
    main: '#D32F2F',
    dark: '#C62828',
    contrastText: '#fff',
  },
  warning: {
    light: '#FFF9C4',
    main: '#FBC02D',
    dark: '#F57F17',
    contrastText: 'rgba(0, 0, 0, 0.87)',
  },
  success: {
    light: '#C8E6C9',
    main: '#2E7D32',
    dark: '#1B5E20',
    contrastText: '#fff',
  },
  info: {
    main: '#0288D1', 
    light: '#03A9F4', 
    dark: '#01579B', 
    contrastText: '#fff'
  },
  background: {
    default: '#F9FAFB',
    paper: '#FFFFFF',
    neutral: '#F4F6F8',
  },
  text: {
    primary: '#1F2937', 
    secondary: '#4B5563', 
    disabled: '#9CA3AF', 
  },
  divider: '#E5E7EB',
  brand: {
    main: '#4A148C',
    light: '#F3E5F5',
    lighter: '#F8F4FF',
    dark: '#311B92',
    contrastText: '#ffffff',
    headerBg: '#9C27B0',
    headerText: '#ffffff',
    rowHover: '#F3E5F5',
  },
};
